const initialState = {
  isLoading: false,
  shares: [],
  activeShare: null,
  suggestions: [],
  noMatches: false,
  selectedPartnerId: null,
  error: null,
  mappingComplete: true,
};

const normalizeSuggestion = (suggestion) => {
  const safeSuggestion = suggestion || {};
  const partner = safeSuggestion.partner || {};

  return {
    ...safeSuggestion,
    id: partner.id || safeSuggestion.id || null,
    company_name: partner.company_name || safeSuggestion.company_name || '',
    email: partner.email || safeSuggestion.email || '',
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_SHARES':
    case 'BEGIN_GET_SHARE_SUGGESTIONS':
    case 'BEGIN_CREATE_SHARE':
    case 'BEGIN_REVOKE_SHARE':
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case 'FAILED_GET_SHARES':
    case 'FAILED_GET_SHARE_SUGGESTIONS':
    case 'FAILED_CREATE_SHARE':
    case 'FAILED_REVOKE_SHARE':
      return {
        ...state,
        isLoading: false,
        error: action.payload?.response?.data?.error || 'An error occurred',
      };

    case 'FINISH_GET_SHARES': {
      const shares = action.payload.data.shares || [];
      const activeShare = action.payload.data.active_share
        || shares.find((share) => share.active)
        || null;
      const mappingComplete = action.payload.data.mapping_complete !== false;
      return {
        ...state,
        isLoading: false,
        shares,
        activeShare,
        mappingComplete,
        error: null,
      };
    }

    case 'FINISH_GET_SHARE_SUGGESTIONS': {
      const rawSuggestions = action.payload.data.suggestions || [];
      const suggestions = rawSuggestions
        .map(normalizeSuggestion)
        .filter((suggestion) => !!suggestion.id);
      const hasSelectedPartner = suggestions.some((suggestion) => suggestion.id === state.selectedPartnerId);
      const noMatchesFromApi = action.payload.data.no_matches;
      return {
        ...state,
        isLoading: false,
        suggestions,
        noMatches: typeof noMatchesFromApi === 'boolean' ? noMatchesFromApi : suggestions.length === 0,
        selectedPartnerId: hasSelectedPartner ? state.selectedPartnerId : null,
        error: null,
      };
    }

    case 'FINISH_CREATE_SHARE':
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case 'FINISH_REVOKE_SHARE':
      return {
        ...state,
        isLoading: false,
        activeShare: null,
        error: null,
      };

    case 'SELECT_SHARE_PARTNER':
      return {
        ...state,
        selectedPartnerId: action.partnerId,
      };

    case 'CLEAR_SHARE_STATE':
      return initialState;

    default:
      return state;
  }
};
